/* eslint-disable no-unused-vars */
import React, { memo, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { Loader, StyledError } from 'components';
// import { ENTITY_PERSON_TYPE } from '@truly-financial/common/consts/entity-person.consts';
import { makeStyles } from '@material-ui/core';
import Logo from 'assets/images/logo/Truly_Logo_Light.png';
import { deprecatedGetTeamMemberDetailsAction, getPersonalDetailsAction } from 'store/Verification/verificationActions';
import { deprecatedGetTeamMemberDetailsState, getPersonalDetailsState } from 'store/Verification/verificationSelectors';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { validateLinkAction } from 'store/User/userActions';
import { validateLinkState } from 'store/User/userSelectors';

const useStyles = makeStyles((theme) => ({
    root: {
        background: 'white',
        minHeight: '100vh',
    },
    infoDiv: {
        textAlign: 'center',
        margin: theme.spacing(10, 1),
    },
    logo: {
        backgroundColor: theme.palette.primary.main,
        padding: theme.spacing(2),
        textAlign: 'left',
        borderRadius: '0px 0px 10px 10px',
        minHeight: theme.spacing(10)
    },
}));

function VerificationRedirect(props = {}) {
    const { personalDetails, linkRes,
        getPersonalDetails, validateLink } = props;

    const classes = useStyles();
    const location = useLocation();
    const { link_id } = useParams();
    let { id = "", token = "" } = queryString.parse(location.search);

    const [personId, setPersonId] = useState(id);

    const [accessToken, setAccessToken] = useState(token);

    const history = useHistory();

    useEffect(() => {
        if (link_id) {
            validateLink({id: link_id});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setPersonId(linkRes.data.entity_person_id);
        setAccessToken(linkRes.data.link_token);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [linkRes.data.link_token]);

    useEffect(() => {
        if (personId && accessToken) {
            handleTeamMemberDetails();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [personId, accessToken]);

    const handleTeamMemberDetails = () => {
        // getPersonalDetails({ personId, token: accessToken });
        getPersonalDetails({access_token: accessToken});
    };

    useEffect(() => {
        if (accessToken && personalDetails.data.entity_person_id) {
            // if (personalDetails.data.entity_person_type === ENTITY_PERSON_TYPE.PRIMARY_CONTACT) {
            //     history.push(`/`);
            // }
            // else 
            if (personalDetails.data.role_id && personalDetails.data.is_signup_required) {
                history.push(`/team-member-signup?token=${accessToken}`);
            }
            else {
                history.push(`/verification?token=${accessToken}`);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [personalDetails]);

    if (linkRes.loading) {
        return (<Loader />)
    }
    
    if (linkRes.error) {
    return (<StyledError data={linkRes} />)
    }

    return (<div className={classes.root}>
        {/* <div className={classes.logo}>
            <img alt="Truly" src={Logo} width="120" />
        </div> */}
        {personalDetails.loading && <Loader />}
        {(personalDetails.status === 404 || personalDetails.error) && <StyledError data={personalDetails} retry={handleTeamMemberDetails} />}
        {(!personalDetails.loading && personalDetails?.data?.entity_person_id && !personalDetails?.data?.access_token) && <StyledError data={{error:{message: 'Invalid token!'}}} />}
    </div>)
}

const mapStateToProps = createStructuredSelector({
    linkRes: validateLinkState(),
    // personalDetails: deprecatedGetTeamMemberDetailsState(),
    personalDetails: getPersonalDetailsState(),
});

function mapDispatchToProps(dispatch) {
    return {
        validateLink: data => dispatch(validateLinkAction(data)),
        // getPersonalDetails: data => dispatch(deprecatedGetTeamMemberDetailsAction(data)),
        getPersonalDetails: data => dispatch(getPersonalDetailsAction(data)),
    };
}

const withConnect = connect(
    mapStateToProps,
    mapDispatchToProps,
);

export default compose(
    withConnect,
    memo,
)(VerificationRedirect);
